import { useEffect, useState } from 'react';
import { getPublicEventsStatus } from '@/services/publicNearMe';

let cached: boolean | null = null;
let inflight: Promise<boolean> | null = null;

function load(): Promise<boolean> {
  inflight ??= getPublicEventsStatus().then((r) => {
    if (r.data) cached = r.data.publicEventsEnabled;
    inflight = null;
    return r.data?.publicEventsEnabled ?? false;
  });
  return inflight;
}

/** Test helper: forget the remembered answer. */
export const resetPublicEventsStatus = (): void => {
  cached = null;
  inflight = null;
};

/** Whether the public events pages are on, or `null` while unknown. Used to decide whether to link to them. */
export function usePublicEventsStatus(): boolean | null {
  const [enabled, setEnabled] = useState<boolean | null>(cached);
  useEffect(() => {
    let cancelled = false;
    if (cached === null) void load().then((v) => !cancelled && setEnabled(v));
    return () => {
      cancelled = true;
    };
  }, []);
  return enabled;
}
